"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sant-andrea-apostolo-dello-ionio": {
    "f7950d89": [{
      "hkey": "3ada6d8a",
      "slug": "sant-andrea-apostolo-dello-jonio-marina",
      "name": "Sant'Andrea Apostolo dello Jonio Marina",
      "primary": true,
      "skipSearch": false
    }],
    "marina-di-sant-andrea-jonio": [{
      "hkey": "3ada6d8a",
      "slug": "sant-andrea-apostolo-dello-jonio-marina",
      "name": "Sant'Andrea Apostolo dello Jonio Marina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;